export default {
      id: "crop-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#crop-usage",
      toString: function () {
        return this.url;
      }
    }